
    import './styles.scoped.css';
    export default {
  "with-motion-vertical": "awsui_with-motion-vertical_b18tp_18zmr_146",
  "with-motion-horizontal": "awsui_with-motion-horizontal_b18tp_18zmr_165",
  "resize-active": "awsui_resize-active_b18tp_18zmr_184",
  "resize-side": "awsui_resize-side_b18tp_18zmr_195",
  "resize-bottom": "awsui_resize-bottom_b18tp_18zmr_198"
};
  